import type { LoggerService } from "@/services/abstract/LoggerService";
import { makeMessageHandler } from "@/services/poc/handlers/makeMessageHandler";

export const createFileReplicationStartedHandler = (loggerService: LoggerService) =>
  makeMessageHandler(
    'fileReplicationStarted',
    'six3ro:p2p:handlers:file-replication-started',
    loggerService,
    (message) => ({
      type: 'fileReplicationStarted',
      data: {
        cid: message.cid,
        sixId: message.sixId,
        totalBytes: message.totalBytes,
        sender: message.sender,
        messageTimestamp: message.timestamp,
      },
    })
  );
